import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { memo } from 'react';
import { Link } from '#components/Link/Link';
import styles from './Logo.module.scss';
import LogoFile from './icons/Logo.svg';
type Props = {
  className?: string;
};
export const Logo = memo(function Logo(t0) {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `${styles.homeLink} ${className} outline-inside`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src={LogoFile} alt={"BR24 Logo | Startseite \xF6ffnen"} unoptimized={true} />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <Link className={t2} title="zur Startseite" href="/">{t3}</Link>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
});